import * as types from '@/constants/mutationTypes'

const state = {
  mainScroll: [],
  countryFlags: [],
  openNotifications: false,
  notificationsList: [],
  rawNotifications: [],
  currentDomain: ''
}
const getters = {
  mainScroll: state => state.mainScroll,
  countryFlags: state => state.countryFlags,
  openNotifications: state => state.openNotifications,
  notificationsList: state => state.notificationsList,
  rawNotifications: state => state.rawNotifications,
  currentDomain: state => state.currentDomain
}
const actions = {
  setCurrentDomain ({commit}, data) {
    commit(types.SET_CURRENT_DOMAIN, {data})
  },
  setMainScroll ({commit}, data) {
    commit(types.SET_MAIN_SCROLL, {data})
  },
  setCountryFlags ({commit}, data) {
    commit(types.SET_COUNTRY_FLAGS, {data})
  },
  setOpenNotifications ({commit}, data) {
    commit(types.SET_OPEN_NOTIFICATIONS, {data})
  },
  setNotificationsList ({commit}, data) {
    commit(types.SET_NOTIFICATIONS_LIST, {data})
  },
  setRawNotifications ({commit}, data) {
    commit(types.SET_RAW_NOTIFICATIONS, {data})
  }
}
const mutations = {
  [types.SET_CURRENT_DOMAIN] (state, {data}) {
    state.currentDomain = data
  },
  [types.SET_MAIN_SCROLL] (state, {data}) {
    state.mainScroll = data
  },
  [types.SET_COUNTRY_FLAGS] (state, {data}) {
    state.countryFlags = data
  },
  [types.SET_OPEN_NOTIFICATIONS] (state, {data}) {
    state.openNotifications = data
  },
  [types.SET_NOTIFICATIONS_LIST] (state, {data}) {
    state.notificationsList = data
  },
  [types.SET_RAW_NOTIFICATIONS] (state, {data}) {
    state.rawNotifications = data
  }
}
export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/Main/modules/store.js